module.exports = __webpack_public_path__ + "static/media/PlanilhaModeloNestlé.c4dd364b.xlsx";